import { Settings } from 'axiosApi/api';

export const SETTINGS_ENDPOINT = 'https://3ksxno08b0.execute-api.us-east-1.amazonaws.com/prod/tenant-fe-config';

export async function fetchRemoteSettings(): Promise<Settings> {
  const response = await fetch(SETTINGS_ENDPOINT);
  return response.json();
}

export function resolveSettings(remote: Settings): Settings {
  return {
    ...remote,
    ...(import.meta.env.DEV ? {
      URL_ADDRESS:        import.meta.env.VITE_URL_ADDRESS        || remote.URL_ADDRESS,
      URL_CLIENTS:        import.meta.env.VITE_URL_CLIENTS        || remote.URL_CLIENTS,
      URL_CONTACTINFO:    import.meta.env.VITE_URL_CONTACTINFO    || remote.URL_CONTACTINFO,
      URL_EMPLOYEE:       import.meta.env.VITE_URL_EMPLOYEE       || remote.URL_EMPLOYEE,
      URL_INVOICE:        import.meta.env.VITE_URL_INVOICE        || remote.URL_INVOICE,
      URL_JOBS:           import.meta.env.VITE_URL_JOBS           || remote.URL_JOBS,
      URL_LOCALE:         import.meta.env.VITE_URL_LOCALE         || remote.URL_LOCALE,
      URL_PROJECT:        import.meta.env.VITE_URL_PROJECT        || remote.URL_PROJECT,
      URL_REPORTS:        import.meta.env.VITE_URL_REPORTS        || remote.URL_REPORTS,
      URL_TIMEOFF:        import.meta.env.VITE_URL_TIMEOFF        || remote.URL_TIMEOFF,
      URL_TIMESHEET:      import.meta.env.VITE_URL_TIMESHEET      || remote.URL_TIMESHEET,
      URL_WORKFLOW:       import.meta.env.VITE_URL_WORKFLOW       || remote.URL_WORKFLOW,
      URL_NOTIFICATIONS:  import.meta.env.VITE_URL_NOTIFICATIONS  || remote.URL_NOTIFICATIONS,
      URL_WSS_NOTIFICATIONS: import.meta.env.VITE_URL_WSS_NOTIFICATIONS || remote.URL_WSS_NOTIFICATIONS,
    } : {}),
    LOGIN_DOMAIN:  import.meta.env.PROD ? remote.LOGIN_DOMAIN  : import.meta.env.VITE_LOGIN_DOMAIN,
    CLIENT_ID:     import.meta.env.PROD ? remote.CLIENT_ID     : import.meta.env.VITE_CLIENT_ID,
    REDIRECT_URL:  import.meta.env.PROD ? remote.REDIRECT_URL  : import.meta.env.VITE_REDIRECT_URL,
    RESPONSE_TYPE: import.meta.env.PROD ? remote.RESPONSE_TYPE : import.meta.env.VITE_RESPONSE_TYPE,
  };
}
